import React from "react";
import { Outlet } from "react-router-dom";
import Browse from "./Browse";

function Main() {
    return (
        <>
            <Browse />
        </>
    )
}

export default Main